import type { LinkCardProps } from "@components/LinkCardProps.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import { Locale } from "@core/schema/Locale.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";
import { getKiosksPath } from "@core/schema/paths/getKiosksPath.js";

export function getSolutionsServices(tenant: Tenant): LinkCardProps[] {
	return [
		{
			title: {
				[Locale.cs]: "Modernizace starých systémů",
				[Locale.en]: "Modernization of old systems",
			}[tenant.locale],
			iconName: brackets,
			href: getDigitalizationAndAutomationPath(tenant),
			show: true,
		},
		{
			title: {
				[Locale.cs]: "Digitalizace",
				[Locale.en]: "Digitalization",
			}[tenant.locale],
			iconName: brackets,
			href: getDigitalizationAndAutomationPath(tenant),
			show: true,
		},
		{
			title: {
				[Locale.cs]: "Automatizace",
				[Locale.en]: "Automation",
			}[tenant.locale],
			iconName: brackets,
			href: getDigitalizationAndAutomationPath(tenant),
			show: true,
		},
		{
			title: {
				[Locale.cs]: "Rozpoznávání",
				[Locale.en]: "Recognition",
			}[tenant.locale],
			iconName: brackets,
			href: "#todo",
			show: false,
		},
		{
			title: {
				[Locale.cs]: "Dodavatelský řetězec",
				[Locale.en]: "Supply chain",
			}[tenant.locale],
			iconName: brackets,
			href: "#todo",
			show: false,
		},
		{
			title: {
				[Locale.cs]: "CRM",
				[Locale.en]: "CRM",
			}[tenant.locale],
			iconName: brackets,
			href: getCrmPath(tenant),
			show: true,
		},
		{
			title: {
				[Locale.cs]: "ERP",
				[Locale.en]: "ERP",
			}[tenant.locale],
			iconName: brackets,
			href: "#todo",
			show: false,
		},
		{
			title: {
				[Locale.cs]: "Kiosková řešení",
				[Locale.en]: "Kiosk solutions",
			}[tenant.locale],
			iconName: brackets,
			href: getKiosksPath(tenant),
			show: true,
		},
		{
			title: {
				[Locale.cs]: "POS",
				[Locale.en]: "POS",
			}[tenant.locale],
			iconName: brackets,
			href: "#todo",
			show: false,
		},
		{
			title: {
				[Locale.cs]: "CMS",
				[Locale.en]: "CMS",
			}[tenant.locale],
			iconName: brackets,
			href: "#todo",
			show: false,
		},
		{
			title: {
				[Locale.cs]: "Audit a optimalizace webů",
				[Locale.en]: "Website audit and optimization",
			}[tenant.locale],
			iconName: brackets,
			href: "#todo",
			show: false,
		},
		{
			title: {
				[Locale.cs]: "Integrace systémů",
				[Locale.en]: "Systems integration",
			}[tenant.locale],
			iconName: brackets,
			href: getIntegrationsPath(tenant),
			show: true,
		},
	];
}
